import { render } from "./curators.vue?vue&type=template&id=1eff3bf5&scoped=true"
import script from "./curators.vue?vue&type=script&lang=js"
export * from "./curators.vue?vue&type=script&lang=js"

import "./curators.vue?vue&type=style&index=0&id=1eff3bf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eff3bf5"]])

export default __exports__